import { TapStreamWriter } from '@iotize/tap/client/impl';
import {
  SinglePacketChunk,
  singlePacketConverters,
  SinglePacketStoreInfo,
  SinglePacketStoreLoader,
} from '@iotize/tap/service/impl/single-packet';
import { POST } from '../annotations';
import { uint32 } from '../converters';
import { TapServerError } from '../tap-server-error';
import { CallContext, VirtualTap } from '../virtual-tap-server';

export class SinglePacketService {
  private config: {
    info: SinglePacketStoreInfo;
    chunks: Uint8Array;
  } = {
    info: {
      state: SinglePacketStoreInfo.State.EMPTY,
    },
    chunks: new Uint8Array(2 * 1024 * 1024),
  };

  private _chunkWriter = new TapStreamWriter(this.config.chunks);

  constructor(public server: VirtualTap) {
    this.server.bindConfigToRoute({
      path: '/1024//81',
      get: true,
      item: () => this.config,
      key: 'info',
      default: {
        state: SinglePacketStoreInfo.State.EMPTY,
      },
      converter: singlePacketConverters.singlePacketStoreInfo,
    });
  }

  @POST({
    path: '/1024//80',
  })
  public writeAndExecuteBytes(context: CallContext<Uint8Array>) {
    this._chunkWriter.pos = 0;
  }

  @POST({
    path: '/1024//82',
    payloadType: singlePacketConverters.singlePacketChunk,
  })
  public writeChunk(context: CallContext<SinglePacketChunk>) {
    const { body } = context;
    const offsetScaling = 16;
    const offsetIndex = body.offset;
    const offset = offsetIndex * offsetScaling;
    // TODO implement unordered chunk
    // For now offset is not ok for esp32 as body.format is always on 2 bytes (instead of 4)
    // console.log('Write chunk at position', offset, body);
    // this._chunkWriter.pos = offset;
    this._chunkWriter.writeBytes(body.data);
  }

  @POST({
    path: '/1024//83',
    payloadType: uint32,
  })
  public executeSinglePacketInStore(context: CallContext<number>) {
    try {
      const crc = context.body;
      const chunks = this._chunkWriter.toBytes;
      console.log(`Execute firmware update size: ${chunks.length} bytes`);
      const expectedCrc = SinglePacketStoreLoader.computeCRC(chunks);
      if (crc !== expectedCrc) {
        console.log(
          `Unexpected firmware update CRC. Expected: ${expectedCrc}. Given: ${crc}`
        );
        throw TapServerError.notAcceptable();
      }
      console.log('FIRMWARE UPDATE SUCCESSFULL');
      this._chunkWriter.pos = 0;
    } finally {
      // Should we clear current packet ?
    }
  }
}
